import * as serviceContext from './serviceContext';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getApiError() {
    try {
        const response = await serviceContext.get("reports/logging/api-errors", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
export async function postApiError(data) {

    try {
        const response = await serviceContext.post("reports/logging/api-errors", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postApiErrorCsv(data) {

    try {
        const response = await serviceContext.post("reports/loggingcsv/api-errors", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};